    const setupDropdownToggle = (element, selector) => {
        const dropdownToggles = element.querySelectorAll(selector);
        dropdownToggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeAllSubmenus(element, selector, toggle);
                const submenu = toggle.nextElementSibling;
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                toggle.setAttribute('aria-expanded', !isExpanded);
                if (submenu) submenu.classList.toggle('show');
            });
        });
    }

    const closeAllSubmenus = (element, selector, currentToggle) => {
        const allToggles = element.querySelectorAll(selector);
        allToggles.forEach(toggle => {
            if (toggle !== currentToggle) {
                const submenu = toggle.nextElementSibling;
                if (submenu && submenu.classList.contains('show')) {
                    submenu.classList.remove('show');
                    toggle.setAttribute('aria-expanded', 'false');
                }
            }
        })
    }


    const setupDropdownBlur = (element) => {
        const dropdownItems = element.querySelectorAll('.dropdown-menu a');
        dropdownItems.forEach(item => {
            item.addEventListener('blur', (e) => {
                const submenu = item.closest('.dropdown-menu');
                setTimeout(() => {
                    if (submenu && !submenu.contains(document.activeElement)) {
                        submenu.classList.remove('show');
                        const toggle = submenu.previousElementSibling;
                        if (toggle && toggle.classList.contains('dropdown-toggle')) {
                            toggle.setAttribute('aria-expanded', 'false');
                        }
                    }
                }, 100);
            });
        });
    }

    const setupDropdownHidden = (element) => {
        const dropdowns = element.querySelectorAll('.dropdown');
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('hidden.bs.dropdown', () => {
                const submenus = dropdown.querySelectorAll('.dropdown-menu');
                submenus.forEach(submenu => {
                    submenu.classList.remove('show');
                    const toggle = submenu.previousElementSibling;
                    if (toggle && toggle.classList.contains('dropdown-toggle')) {
                        toggle.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        });
    }

    export {
        setupDropdownToggle,
        setupDropdownBlur,
        setupDropdownHidden
    };

